// src/components/ProtectedRoute.js
import React, { useContext, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({
  children,
  allowedRoles = [],
  requiresAuth = true,
  skipRoleCheck = false,
  requiresApproval = false,
}) => {
  const location = useLocation();
  const { user, loading } = useContext(AuthContext);

  const role = useMemo(() => {
    const r = user?.role ?? null;
    return typeof r === 'string' ? r.trim().toLowerCase() : null;
  }, [user]);

  const status = (user?.status || '').toString().trim().toLowerCase();
  const allowed = allowedRoles.map(r => r.toLowerCase());

  console.log('[Guard] route check', {
    path: location.pathname,
    requiresAuth,
    skipRoleCheck,
    requiresApproval,
    userPresent: !!user,
    role,
    status,
    allowedRoles: allowed,
  });

  if (loading) return null;

  if (requiresAuth && !user) {
    console.log('[Guard] redirect -> /login');
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (skipRoleCheck) {
    console.log('[Guard] skipRoleCheck: allow');
    return children;
  }

  if (allowed.length > 0 && (!role || !allowed.includes(role))) {
    console.log('[Guard] role denied -> /unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiresApproval) {
    if (status === 'pending') {
      const base = role === 'supplier' ? 'supplier' : role === 'user' ? 'user' : 'admin';
      console.log('[Guard] pending -> redirect', `/${base}/pending-approval`);
      return <Navigate to={`/${base}/pending-approval`} replace />;
    }
    if (status === 'suspended' || status === 'rejected') {
      console.log('[Guard] suspended/rejected -> /account-suspended');
      return <Navigate to="/account-suspended" replace />;
    }
  }

  console.log('[Guard] allow');
  return children;
};

export default ProtectedRoute;
